import { Consts } from '@dm/core';

export interface IndicatorMapItem {
    value?: number;
    type?: string;
    unit?: string;
    i18n?: string;
}

// 这里的unit和返回数据的unit不一定一致
export const indicatorE: {
    [key: string]: IndicatorMapItem;
} = {
    indicator_1324: {
        value: 1324,
        type: 'iops',
        unit: 'IO/s',
        i18n: 'storage.smartQoS_task_normalizedReadIOPS_lab',
    },
    indicator_1325: {
        value: 1325,
        type: 'iops',
        unit: 'IO/s',
        i18n: 'storage.smartQoS_task_normalizedWriteIOPS_lab',
    },
    indicator_23: {
        value: 23,
        type: 'capacity',
        unit: Consts.MB,
        i18n: 'storage.smartQoS_task_readBandwith_lab',
    },
    indicator_26: {
        value: 26,
        type: 'capacity',
        unit: Consts.MB,
        i18n: 'storage.smartQoS_task_writeBandwith_lab',
    },
    indicator_25: {
        value: 25,
        type: 'iops',
        unit: 'IO/s',
        i18n: 'storage.smartQoS_task_readIOPS_lab',
    },
    indicator_28: {
        value: 28,
        type: 'iops',
        unit: 'IO/s',
        i18n: 'storage.smartQoS_task_writeIOPS_lab',
    },
    bandWidth: {
        value: 21,
        type: 'capacity',
        unit: Consts.MB,
        i18n: 'home.performance_term_blockBandwidth_title',
    },
    totalIops: {
        value: 22,
        type: 'iops',
        unit: 'IO/s',
        i18n: 'home.performance_term_totalIOPS_label',
    },
    iops: {
        value: 22,
        type: 'iops',
        unit: 'IO/s',
        i18n: 'storage.smartQoS_term_IOPS_label',
    },
    // 平均I/O响应时间
    avgIoLatency: {
        value: 370,
        type: 'time',
        unit: 'us',
        i18n: 'home.performance_term_averageRequstTime_title',
    },
    readLatency: {
        value: 384,
        type: 'time',
        unit: 'ms',
        i18n: 'home.performance_term_averageRequstTime_title',
    },
    writeLatency: {
        value: 385,
        type: 'time',
        unit: 'ms',
        i18n: 'home.performance_term_averageRequstTime_title',
    },
    normalIops: {
        value: 810,
        type: 'iops',
        unit: 'IO/s',
        i18n: 'storage.smartQoS_view_task_summary_NormalizedIOPS_lab',
    },
    avgCpuUsage: {
        value: 68,
    },
    normalLatency: {
        value: 1211,
        type: 'time',
        unit: 'us',
        i18n: 'storage.smartQoS_term_normalizedLatency_label',
    },
    fileBandwidth: {
        value: 511,
        type: 'capacity',
        unit: Consts.KB,
        i18n: 'home.performance_term_fileBandwidth_lab',
    },
    fileOps: {
        value: 182,
        type: 'ops',
        i18n: 'home.performance_term_OPS_lab',
    },
    // 平均操作时延
    avgLatency: {
        value: 508,
        type: 'time',
        unit: 'us',
        i18n: 'home.performance_term_AvgOperLatency_lab',
    },
    serviceTime: {
        value: 523,
        type: 'time',
        unit: 'us',
        i18n: 'monitor.charts_term_serviceTime_lab',
    },
    allBandWidth: {
        value: 1231,
        type: 'capacity',
        unit: Consts.KB,
        i18n: 'monitor.performance_term_view_totalBandwith_lab',
    },
    allIops: {
        value: 1229,
        type: 'iops',
        unit: 'IO/s',
        i18n: 'monitor.performance_term_view_totalIOPS_lab',
    },
    allLatency: {
        value: 1230,
        type: 'time',
        unit: 'ms',
        i18n: 'monitor.performance_term_view_totaLatency_lab',
    },
    receivedPacketsPerSec: {
        value: 6666,
        type: 'time',
        unit: 'ms',
        i18n: 'monitor.monitor_reporter_term_ReciveDataPackage_label',
    },
    transmittedPacketsPerSec: {
        value: 7777,
        type: 'time',
        unit: 'ms',
        i18n: 'monitor.monitor_reporter_term_SendDataPackage_label',
    },
    receivedBytesPerSec: {
        value: 8888,
        type: 'capacity',
        unit: Consts.KB,
        i18n: 'monitor.monitor_reporter_term_inBytes_label',
    },
    transmittedBytesPerSec: {
        value: 9999,
        type: 'capacity',
        unit: Consts.KB,
        i18n: 'monitor.monitor_reporter_term_outBytes_label',
    },
    indicator_703: {
        value: 703,
        type: 'capacity',
        unit: Consts.KB,
        i18n: 'monitor.performance_term_NFSBandwidth_sortBy_value',
    },
    indicator_721: {
        value: 721,
        type: 'ops',
        i18n: 'monitor.performance_term_NFSOPS_sortBy_value',
    },
    indicator_745: {
        value: 745,
        type: 'time',
        unit: 'us',
        i18n: 'monitor.performance_term_NFSResponseTime_sortBy_value',
    },
    indicator_706: {
        value: 706,
        type: 'capacity',
        unit: Consts.KB,
        i18n: 'monitor.performance_term_CIFSBandwidth_sortBy_value',
    },
    indicator_724: {
        value: 724,
        type: 'ops',
        i18n: 'monitor.performance_term_CIFSOPS_sortBy_value',
    },
    indicator_748: {
        value: 748,
        type: 'time',
        unit: 'us',
        i18n: 'monitor.performance_term_CIFSResponseTime_sortBy_value',
    },
    /**
     * 利用率(%)
     */
    usage: {
        value: 18,
    },
};

export const IndicatorMap: {
    [key: number]: IndicatorMapItem;
} = {
    // 块带宽
    21: indicatorE.bandWidth,
    // iops
    22: indicatorE.iops,
    // 平均I/O响应时间
    370: indicatorE.avgIoLatency,
    // 平均读I/O响应时间
    384: indicatorE.readLatency,
    // 平均写I/O响应时间
    385: indicatorE.writeLatency,
    // 标准IOPS
    810: indicatorE.normalIops,
    // 标准化时延
    1211: indicatorE.normalLatency,
    // 文件带宽
    511: indicatorE.fileBandwidth,
    182: indicatorE.fileOps,
    508: indicatorE.avgLatency,
    523: indicatorE.serviceTime,
    // 总带宽
    1231: indicatorE.allBandWidth,
    // 总IOPS
    1229: indicatorE.allIops,
    // 总操作时延
    1230: indicatorE.allLatency,
    // 接收数据包
    6666: indicatorE.receivedPacketsPerSec,
    // 发送数据包
    7777: indicatorE.transmittedPacketsPerSec,
    // 接收字节数
    8888: indicatorE.receivedBytesPerSec,
    // 发送字节数
    9999: indicatorE.transmittedBytesPerSec,
    // NFS总带宽
    703: indicatorE.indicator_703,
    // NFS总OPS
    721: indicatorE.indicator_721,
    // NFS I/O平均响应时间
    745: indicatorE.indicator_745,
    // CIFS总带宽
    706: indicatorE.indicator_706,
    // CIFS总OPS
    724: indicatorE.indicator_724,
    // CIFS I/O平均响应时间
    748: indicatorE.indicator_748,
    23: indicatorE.indicator_23,
    26: indicatorE.indicator_26,
    25: indicatorE.indicator_25,
    28: indicatorE.indicator_28,
    1324: indicatorE.indicator_1324,
    1325: indicatorE.indicator_1325,
};
